import { tertiaryDark } from "style/colors";

export const topZIndex = 100;
export const snapGuideZIndex = 10;
export const sectionZIndex = 1;

export const sectionGutter = 6;
export const layerMargin = 5;

export const sectionHeight = 42;
export const baseSectionHeight = 75;
export const audioSectionHeight = 30;
export const captionSectionHeight = 28;

export const layerHeight = sectionHeight + sectionGutter * 2;
export const baseLayerHeight = baseSectionHeight + sectionGutter * 2;
export const audioLayerHeight = audioSectionHeight + sectionGutter * 2;
export const captionLayerHeight = captionSectionHeight + sectionGutter * 2;

export const layerBg = tertiaryDark;
export const sectionBorder = `#00e3ad`;
export const templateSectionBackground = `#596281`;
export const captionSectionBackground = `#596281`;
export const captionSectionBorder = `#8983FF`;

export const transitionBg = `rgba(255, 255, 255)`;
export const transitionBgActive = `rgba(255, 196, 97)`;
export const transitionBgTransparent = `rgba(255, 255, 255, 0.6)`;
export const transitionBgTransparentActive = `rgba(255, 196, 97, .75)`;

export const assetOutline = `#C9DAF8`;
export const assetBorderRadius = 5;
export const assetHandleWidth = 7;
